// Ensure cart drawer state doesn't leak between pages
document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.remove('scroll-lock', 'no-scroll');
  document.body.classList.remove(
    'scroll-lock',
    'no-scroll',
    'drawer-open',
    'cart-drawer-open',
    'modal-open'
  );

  // Remove any leftover inline styles used for scroll locking
  document.documentElement.style.removeProperty('overflow');
  document.body.style.removeProperty('overflow');
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('width');
});